exports.f = Object.getOwnPropertySymbols;


//////////////////
// WEBPACK FOOTER
// /home/readymade/apps/facelift_production/shared/~/core-js/modules/_object-gops.js
// module id = 196
// module chunks = 0